module.exports = "/assets/data/619169232d5870ac1de577ed35226ed6-RM10.data.json";